import AgentWithdrawModal from "./agent-withdraw-modal";

export default AgentWithdrawModal;
